export const colors = {
  brandPrimaryDefault: "#0070EB",
  brandPrimaryTint: "#C8E2FF",
  brandPrimaryShade: "#004EA3",
  brandGradientDefault: "linear-gradient(125deg, #2B2D2E 0%, #0a0a0a 100%)",
  brandGradientColorStopsStart: "#2B2D2E",
  brandGradientColorStopsEnd: "#0a0a0a",
  contentBrandPrimary: "#0070EB",
  backgroundBrand: "#0070EB",
  borderBrand: "#0070EB",
};

export const text = {
  themeName: "Sportsbook Dark",
};